"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzFilter = void 0;
var coveo_search_ui_1 = require("coveo-search-ui");
var AzFilter = /** @class */ (function (_super) {
    __extends(AzFilter, _super);
    function AzFilter(element, options, bindings) {
        var _this = _super.call(this, element, AzFilter.ID, bindings) || this;
        _this.element = element;
        _this.options = options;
        _this.bindings = bindings;
        _this.letters = [
            'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
        ];
        _this.options = coveo_search_ui_1.ComponentOptions.initComponentOptions(element, AzFilter, options);
        _this.initComponent(element);
        _this.initQueryStateEvents();
        _this.initBreadCrumbEvents();
        _this.bind.onRootElement(coveo_search_ui_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
        _this.bind.onRootElement('state:change:' + _this.getFacetField(), function (args) { return _this.handleQueryStateChanged(args); });
        return _this;
    }
    AzFilter.prototype.initComponent = function (element) {
        var _this = this;
        // created ordered list for letters
        this.list = (0, coveo_search_ui_1.$$)('ol', {
            className: 'alpha'
        }).el;
        // append ordered list to root element
        element.appendChild(this.list);
        var _loop_1 = function () {
            var filter = (0, coveo_search_ui_1.$$)('li', {
                className: 'alpha-item'
            });
            filter.el.appendChild((0, coveo_search_ui_1.$$)('button', {
                className: 'button button--alpha alpha__link',
                type: 'button'
            }, this_1.letters[i]).el);
            // map click to button
            (function (letter) {
                var clickAction = function () { return _this.handleLetterClick(letter); };
                filter.on('click', clickAction);
                filter.on('keyup', coveo_search_ui_1.KeyboardUtils.keypressAction(coveo_search_ui_1.KEYBOARD.ENTER, clickAction));
            })(this_1.letters[i]);
            this_1.list.appendChild(filter.el);
        };
        var this_1 = this;
        // for every letter, create an li and add an anchor with the letter at text
        for (var i = 0; i < this.letters.length; i++) {
            _loop_1();
        }
    };
    AzFilter.prototype.initQueryStateEvents = function () {
        this.queryStateModel.registerNewAttribute(this.getFacetField(), '');
    };
    AzFilter.prototype.initBreadCrumbEvents = function () {
        var _this = this;
        this.bind.onRootElement(coveo_search_ui_1.BreadcrumbEvents.populateBreadcrumb, function (args) {
            return _this.handlePopulateBreadcrumb(args);
        });
        this.bind.onRootElement(coveo_search_ui_1.BreadcrumbEvents.clearBreadcrumb, function (args) { return _this.clearLetterFilter(); });
    };
    AzFilter.prototype.handlePopulateBreadcrumb = function (args) {
        var _this = this;
        if (this.selectedLetter) {
            var addedElement = void 0;
            addedElement = (0, coveo_search_ui_1.$$)('div', {
                className: 'coveo-facet-breadcrumb',
            });
            var title = (0, coveo_search_ui_1.$$)('span', {
                className: 'coveo-facet-breadcrumb-title'
            }, 'Last Name Letter:');
            var values = (0, coveo_search_ui_1.$$)('span', {
                className: 'coveo-facet-breadcrumb-values'
            });
            var value = (0, coveo_search_ui_1.$$)('span', {
                className: 'coveo-facet-breadcrumb-value coveo-selected',
            });
            var caption = (0, coveo_search_ui_1.$$)('span', {
                className: 'coveo-facet-breadcrumb-caption'
            }, this.selectedLetter);
            var clear = (0, coveo_search_ui_1.$$)('span', {
                className: 'coveo-facet-breadcrumb-clear'
            }, '<svg focusable="false" enable-background="new 0 0 13 13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Clear"><title>Clear</title><g fill="currentColor"><path d="m7.881 6.501 4.834-4.834c.38-.38.38-1.001 0-1.381s-1.001-.38-1.381 0l-4.834 4.834-4.834-4.835c-.38-.38-1.001-.38-1.381 0s-.38 1.001 0 1.381l4.834 4.834-4.834 4.834c-.38.38-.38 1.001 0 1.381s1.001.38 1.381 0l4.834-4.834 4.834 4.834c.38.38 1.001.38 1.381 0s .38-1.001 0-1.381z"></path></g></svg>');
            value.on('click', function () {
                _this.clearLetterFilter();
            });
            value.el.appendChild(caption.el);
            value.el.appendChild(clear.el);
            values.el.appendChild(value.el);
            addedElement.el.appendChild(title.el);
            addedElement.el.appendChild(values.el);
            args.breadcrumbs.push({ element: addedElement.el });
        }
    };
    AzFilter.prototype.handleQueryStateChanged = function (args) {
        if (args && args.value) {
            this.selectedLetter = args.value;
            this.queryController.executeQuery();
        }
    };
    AzFilter.prototype.updateQueryState = function () {
        this.queryStateModel.set(this.getFacetField(), this.selectedLetter);
    };
    AzFilter.prototype.clearLetterFromQueryState = function () {
        this.queryStateModel.set(this.getFacetField(), undefined);
    };
    AzFilter.prototype.handleBuildingQuery = function (args) {
        if (this.selectedLetter) {
            this.updateQueryState();
            args.queryBuilder.advancedExpression.addFieldExpression(this.options.field.toString(), '==', [this.selectedLetter]);
        }
    };
    AzFilter.prototype.handleLetterClick = function (letter) {
        this.selectedLetter = letter;
        this.queryController.executeQuery();
    };
    AzFilter.prototype.clearLetterFilter = function () {
        this.selectedLetter = undefined;
        this.clearLetterFromQueryState();
        this.queryController.executeQuery();
    };
    AzFilter.prototype.getFacetField = function () {
        return 'f:' + this.options.field.toString();
    };
    AzFilter.ID = 'AzFilter';
    AzFilter.options = {
        field: coveo_search_ui_1.ComponentOptions.buildFieldOption({ required: true })
    };
    return AzFilter;
}(coveo_search_ui_1.Component));
exports.AzFilter = AzFilter;
coveo_search_ui_1.Initialization.registerAutoCreateComponent(AzFilter);
